/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function TemperatureAddIcon(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <mask
        id='temperature-add_svg__a'
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha',
        }}
      >
        <path fill='#2196F3' d='M0 0h18v18H0z' />
      </mask>
      <g mask='url(#temperature-add_svg__a)'>
        <path
          fill='#9DA1A9'
          d='M8.25 14.25v-4.5h-4.5v-1.5h4.5v-4.5h1.5v4.5h4.5v1.5h-4.5v4.5z'
        />
      </g>
    </svg>
  )
}
